// AI-CONTEXT: See docs/features/team-availability.md (schedule field shape)

import isTaskWithinPersonaSchedule from './isTaskWithinPersonaSchedule'

// Warns about planning errors: the occurrence is assigned to team members, at
// least one of them has rooster data, and none of their roosters covers the
// slot. Deliberately NOT the negation of isTaskWithinPersonaSchedule — tenants
// that don't maintain roosters (no schedule docs for the member) get no warning.
//
// Takes one rendered occurrence (plain local Dates), like
// personaAbsenceClassNames — a recurring series is one event with many
// occurrences, so this must be called per occurrence, not per task doc.
// AI-CONTEXT: See docs/pitfalls.md#state-recurring-event-wrong-date
const isTaskOutsidePersonaSchedule = (slot, personaSchedules) => {
    if (!slot || slot.type === 'personaSchedule') return false
    if (!Array.isArray(personaSchedules) || personaSchedules.length === 0) return false

    const members = Array.isArray(slot.teamMembers) ? slot.teamMembers : []
    if (members.length === 0) return false

    // All-day occurrences (no end time) have no slot to check.
    if (!(slot.start instanceof Date) || !(slot.end instanceof Date)) return false

    const memberSet = new Set(members)
    const hasRoosterData = personaSchedules.some(
        (sched) => sched?.Type === 'personaSchedule' && memberSet.has(sched.PersonaID)
    )
    if (!hasRoosterData) return false

    // Reuse the task-shaped within-check by wrapping the plain dates in
    // Firestore-Timestamp-shaped objects.
    return !isTaskWithinPersonaSchedule(
        {
            Type: slot.type,
            TeamMembers: members,
            Timestamp: { toDate: () => slot.start },
            TimestampEnd: { toDate: () => slot.end },
        },
        personaSchedules
    )
}

export default isTaskOutsidePersonaSchedule
